import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=734e1a91&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=734e1a91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e1a91",
  null
  
)

export default component.exports